export const getters = {
  modalOpen: ({ modalOpen }) => modalOpen,
  hypothequesMaritimes: ({ hypothequesMaritimes }) => hypothequesMaritimes,
  saisiesNavires: ({ saisiesNavires }) => saisiesNavires,
  hypothequesRIF: ({ hypothequesRIF }) => hypothequesRIF,
};
